export default function reversePositionInRange(position, rangeLength, isInBetweenPositions) {
  return rangeLength - position - (isInBetweenPositions ? 0 : 1);
}
